import React from "react";
import { Link } from "react-router-dom";

function InvestingInRealEstateHome() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-InvestRealState">
      <div className="container d-flex flex-column align-items-center justify-content-center vh-100">
            <div className=" d-flex flex-column justify-content-center align-items-center  text-center">
             <div className="bg-white rounded-border Content-Top py-2 px-5 border border-4 border-dark">
                    <div className="col-12 heading-font">
                        <h1 className="mb-0">Investing In Real Estate</h1>
                    </div>
                </div>
                {/* <p className="mb-0  py-1 fs-2">Investing In Real Estate</p> */}
             
                <Link  to={'/investing-in-real-estate/first-step'} className="btn Content-Bottom btn-warning btn-lg px-5 border-3 border-white fw-bold inner-shadow  mt-2">
                    Let’s Begin
                </Link>
            </div>
        </div>
      </div>
    </>
  );
}

export default InvestingInRealEstateHome;
